import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Paper, 
  Card, 
  CardContent, 
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { 
  QuestionAnswer as QuestionIcon, 
  Category as CategoryIcon, 
  Assignment as QuestionnaireIcon, 
  Feedback as ResponseIcon 
} from '@mui/icons-material';
import axios from 'axios';

const Dashboard = () => {
  const [stats, setStats] = useState({
    questions: 0,
    categories: 0,
    questionnaires: 0,
    responses: 0,
    recentResponses: []
  });

  useEffect(() => {

    axios.get(`${process.env.REACT_APP_API_URL}/admin/dashboard`)
      .then(response => {
        if (response.data.success) {
          setStats(response.data.data);
        }
      })
      .catch(error => {
        console.error('Error fetching dashboard data:', error);
      });
  
  }, []);

  const StatCard = ({ title, value, icon, color }) => (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ 
            backgroundColor: `${color}.light`, 
            borderRadius: '50%', 
            p: 1, 
            mr: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {icon}
          </Box>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Box>
        <Typography variant="h3" component="div" sx={{ textAlign: 'center', my: 2 }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Dashboard
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard 
            title="Questions" 
            value={stats.questions} 
            icon={<QuestionIcon sx={{ color: 'primary.main' }} />} 
            color="primary" 
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard 
            title="Categories" 
            value={stats.categories} 
            icon={<CategoryIcon sx={{ color: 'success.main' }} />} 
            color="success" 
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard 
            title="Questionnaires" 
            value={stats.questionnaires} 
            icon={<QuestionnaireIcon sx={{ color: 'info.main' }} />} 
            color="info" 
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard 
            title="Responses" 
            value={stats.responses} 
            icon={<ResponseIcon sx={{ color: 'warning.main' }} />} 
            color="warning" 
          />
        </Grid>
      </Grid>
      
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Recent Responses
        </Typography>
        <List>
          {stats.recentResponses.map((response, index) => (
            <React.Fragment key={response.id}>
              <ListItem>
                <ListItemText 
                  primary={response.questionnaire} 
                  secondary={`${response.respondent} - ${response.date}`} 
                />
              </ListItem>
              {index < stats.recentResponses.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default Dashboard;
